import type { QuickStartTaskResult } from '@/lib/api/setup.types';

const ACTION_PRIORITY: Record<QuickStartTaskResult['status'], number> = {
  pending: 0,
  not_started: 1,
  locked: 2,
  completed: 3,
};

export const sortTasksByActionPriority = (tasks: QuickStartTaskResult[]) =>
  [...tasks].sort((a, b) => ACTION_PRIORITY[a.status] - ACTION_PRIORITY[b.status]);

export const groupTasksByTier = (tasks: QuickStartTaskResult[]) => ({
  // Required follows the launch path: next action first, locked steps next,
  // completed steps sink to the bottom.
  required: sortTasksByActionPriority(tasks.filter((task) => task.tier === 'required')),
  // Recommended & optional keep the registry's editorial order.
  recommended: tasks.filter((task) => task.tier === 'recommended'),
  optional: tasks.filter((task) => task.tier === 'optional'),
});
